/* eslint-disable react/no-unstable-nested-components */
import React from 'react'
import { ErrorBoundary } from '@sentry/react'
import { connect } from 'react-redux'
import { useCookies } from 'react-cookie'
import { useLocaleActions } from '@merchant-portal/merchant-portal-base'
import { Button, Column, Columns } from '@resurs/midas-react'
import { logout } from '../store/actions/auth-actions'
import logo from '../assets/img/logo.svg'
import { errorAnimation } from '../assets/animations'
import { getText } from '../internal/TextLabels'
import PageWrapper from '../internal/PageWrapper'

const SentryErrorBoundary = props => {
  const [, , removeCookie] = useCookies(['store', 'country'])
  const localeActions = useLocaleActions()

  return (
    <ErrorBoundary
      fallback={() => {
        return (
          <>
            <style>{'body { background-color: #F6F7F8'}</style>
            <div
              style={{
                backgroundColor: '#FFFFFF',
                borderBottom: '1px solid #ddd',
                height: '69px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  paddingLeft: '1.8rem',
                }}
              >
                <img alt="logo" src={logo} style={{ width: '124px' }} />
              </div>
            </div>

            <Columns>
              <Column col1 colMd0 />
              <Column col10 colMd12>
                <div style={{ display: 'flex' }}>
                  <img
                    style={{ margin: '1rem 1rem 1rem 0' }}
                    src={errorAnimation}
                    alt="Error animation"
                  />
                  <h4
                    style={{
                      margin: '2.2rem 1rem 0 0',
                      display: 'inline-block',
                    }}
                  >
                    {getText('errorBoundary.title')}
                  </h4>
                </div>
              </Column>
            </Columns>
            <PageWrapper type="danger" noPadding>
              <div
                style={{
                  padding: '2rem',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Columns>
                  <Column noPadding>
                    <h4 style={{ margin: 0, paddingRight: '4rem' }}>
                      {getText('errorBoundary.fixErrorTitle')}
                    </h4>
                    <p style={{ marginTop: '3rem' }}>
                      {getText('errorBoundary.fixErrorDescription')}
                    </p>
                    <div style={{ float: 'right' }}>
                      <Button
                        onClick={event => {
                          event.preventDefault()
                          localStorage.removeItem('push-out-checked')
                          removeCookie('store')
                          removeCookie('country')
                          localeActions.setLanguage('')
                          localeActions.setCountry('')
                          props.logout()
                        }}
                        typeName="primary"
                      >
                        {getText('errorBoundary.restore')}
                      </Button>
                    </div>
                  </Column>
                </Columns>
              </div>
            </PageWrapper>
          </>
        )
      }}
    >
      {props.children}
    </ErrorBoundary>
  )
}

const mapDispatchToProps = dispatch => ({
  logout: () => {
    dispatch(logout())
  },
})

export default connect(null, mapDispatchToProps)(SentryErrorBoundary)
